import { render, staticRenderFns } from "./ErrorMsgUser.vue?vue&type=template&id=8882096c&scoped=true&"
import script from "./ErrorMsgUser.vue?vue&type=script&lang=js&"
export * from "./ErrorMsgUser.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMsgUser.vue?vue&type=style&index=0&id=8882096c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8882096c",
  null
  
)

export default component.exports